import React from 'react';
import { Form, Col } from 'antd';
import { translate } from 'react-i18next';

import Input from 'components/Fields/Input';

import styles from './Profile.module.scss';

const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20, offset: 2 },
  },
};

const ProfileContact = ({ contact, defaultPosition, disabled, t }) => (
  <div>
    <FormItem {...formItemLayout}>
      <Col span={12} className={styles.Col}>
        <Input
          model=".firstname"
          label={t('Prénom')}
          errorMessages={{ required: { message: t('Ce champ est obligatoire') } }}
        />
      </Col>
      <Col span={12} className={styles.Col}>
        <Input
          model=".lastname"
          label={t('Nom')}
          errorMessages={{ required: { message: t('Ce champ est obligatoire') } }}
        />
      </Col>
    </FormItem>
    <FormItem {...formItemLayout}>
      <Col span={24} className={styles.Col}>
        <Input
          model=".position"
          defaultValue={defaultPosition}
          disabled={disabled}
          label={t('Fonction dans la structure')}
        />
      </Col>
    </FormItem>
    <FormItem {...formItemLayout}>
      <Col span={6} className={styles.Col}>
        <Input
          model=".zipcode"
          label={t('Code postal')}
        />
      </Col>
      <Col span={18} className={styles.Col}>
        <Input
          model=".city"
          label={t('Ville')}
        />
      </Col>
    </FormItem>
    <FormItem {...formItemLayout}>
      <Col span={7} className={styles.Col}>
        <Input
          model=".phone[0]"
          label={t('Téléphone')}
          errorMessages={{ required: { message: t('Ce champ est obligatoire') } }}
        />
      </Col>
      <Col span={7} className={styles.Col}>
        <Input
          model=".phone[1]"
          label={t('Téléphone secondaire')}
        />
      </Col>
    </FormItem>
    <FormItem {...formItemLayout}>
      <Col span={24} className={styles.Col}>
        <Input
          model=".email"
          label="Email"
          id={`contact-email_${contact.uid}`}
        />
      </Col>
    </FormItem>
  </div>
);

export default translate('profileContactTranslations')(ProfileContact);



// WEBPACK FOOTER //
// ./src/components/Profile/User/ProfileContact.js